import type { DependencyList, EffectCallback } from 'react'
import { useEffect, useLayoutEffect } from 'react'

// eslint-disable-next-line import/prefer-default-export
export function useIsomorphicLayoutEffect(
  effect: EffectCallback,
  deps?: DependencyList
) {
  return (typeof window !== 'undefined' ? useLayoutEffect : useEffect)(
    effect,
    deps
  )
}
